import { http } from "./http";

export const countiesApi = {
  list: (params) => http.get("/counties", { params }).then((r) => r.data),
  getById: (id) => http.get(`/counties/${id}`).then((r) => r.data),
  create: (payload) => http.post("/counties", payload).then((r) => r.data),
  update: (id, payload) =>
    http.put(`/counties/${id}`, payload).then((r) => r.data),
};
